export interface PeriodoAcademico {
    valortasas: number,
    valorEstudespol: number,
    idperiodopadre: number,
    fechainiclases: Date,
    fechaActualizacion: Date,
    fechamaxcambiosplanif: Date,
    subperiodo: string,
    fechafinplanif: Date,
    idperiodo: number,
    fechafin: Date,
    estado: string,
    fechainipreregistro: Date,
    fechafinpreregistro: Date,
    fechafineval3: Date,
    fechafineval1: Date,
    fechainicioregist: Date,
    valormateriaextranjero2: number,
    tipo: string,
    idpromocion: number,
    fechainicio: Date,
    fechainiregistro: Date,
    fechafinregistro: Date,
    fechainieval1: Date,
    fechainieval2: Date,
    fechainieval4: Date,
    fechafineval2: Date,
    fechainieval3: Date,
    fechafineval4: Date,
    fechainieval5: Date,
    fechafineval5: Date,
    nombre: string,
    fechainimejo: Date,
    fechafinmejo: Date,
    anio: string,
    siglas: string,
    termino: string,
    fechafinregist: Date,
    fechamaxcursonuevo: Date,
    valormateria: number,
    valormateriaextranjero: number,
    valormodulares: number,
    fechavencimiento: Date,
    valormateria3: number,
    valormateriaextranjero3: number,
    valormateria2: number,
    fechafinclases: Date,
    esderegistro: string,
    periodo: string,
    fechainicioplanif: Date,
    fechainiampliacion: Date,
    fechafinampliacion: Date,
    fechainiaprobampliacion: Date,
    fechafinaprobampliacion: Date,
    tipoperiodo: string,
    fechaaprobplanif: Date,
    factorpre: number,
    version: number,
    idparametro: number,
    fechamaximocambioca: Date,
    fechamaximacambioc: Date,
    fechamaxmatespecial: Date,
    fechamaximaeliminarr: Date
}

export function VoidPeriodoAcademico(): PeriodoAcademico {
    const fechaNula = new Date(1, 0, 1);
    return {
        valortasas: 0,
        valorEstudespol: 0,
        idperiodopadre: 0,
        fechainiclases: fechaNula,
        fechaActualizacion: fechaNula,
        fechamaxcambiosplanif: fechaNula,
        subperiodo: '',
        fechafinplanif: fechaNula,
        idperiodo: 0,
        fechafin: fechaNula,
        estado: '',
        fechainipreregistro: fechaNula,
        fechafinpreregistro: fechaNula,
        fechafineval3: fechaNula,
        fechafineval1: fechaNula,
        fechainicioregist: fechaNula,
        valormateriaextranjero2: 0,
        tipo: '',
        idpromocion: 0,
        fechainicio: fechaNula,
        fechainiregistro: fechaNula,
        fechafinregistro: fechaNula,
        fechainieval1: fechaNula,
        fechainieval2: fechaNula,
        fechainieval4: fechaNula,
        fechafineval2: fechaNula,
        fechainieval3: fechaNula,
        fechafineval4: fechaNula,
        fechainieval5: fechaNula,
        fechafineval5: fechaNula,
        nombre: '',
        fechainimejo: fechaNula,
        fechafinmejo: fechaNula,
        anio: '',
        siglas: '',
        termino: '',
        fechafinregist: fechaNula,
        fechamaxcursonuevo: fechaNula,
        valormateria: 0,
        valormateriaextranjero: 0,
        valormodulares: 0,
        fechavencimiento: fechaNula,
        valormateria3: 0,
        valormateriaextranjero3: 0,
        valormateria2: 0,
        fechafinclases: fechaNula,
        esderegistro: '',
        periodo: '',
        fechainicioplanif: fechaNula,
        fechainiampliacion: fechaNula,
        fechafinampliacion: fechaNula,
        fechainiaprobampliacion: fechaNula,
        fechafinaprobampliacion: fechaNula,
        tipoperiodo: '',
        fechaaprobplanif: fechaNula,
        factorpre: 0,
        version: 0,
        idparametro: 0,
        fechamaximocambioca: fechaNula,
        fechamaximacambioc: fechaNula,
        fechamaxmatespecial: fechaNula,
        fechamaximaeliminarr: fechaNula
    }
}